var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricing-option"},[_c('label',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.$t("inventory.cumulative_pricing")))]),_vm._v(" "),_c('DynamicFormComponent',{ref:"priceForm",attrs:{"model":_vm.model,"fieldsConfig":_vm.form}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }